<script lang="ts" setup>
  import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as planoService from "@/services/planosService";
  import {f2dec} from "@/utils/funcoes";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";

  var controle = reactive({
    filtros: {
      statusId: null,
      tipoId: null,
      paginaAtual: 1,
      tamanhoPagina: 20
    } as unknown as planoService.Filtros,
    itens: [] as planoService.Plano[],

    tipos: ['- Todos -','Particular','Empresarial'] ,
    listaStatus:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},       
      {valor: false, descricao:"Inativos"},
    ],

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    
    pesquisar();
  })

  async function pesquisar() {

    planoService.obter(controle.filtros)
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }
</script>

<template>
  <BreadCrumb PageTitle="Planos" />

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-3">
          <label><i class="flaticon-search"></i> Pesquisar</label>
          <input type="text" class="form-control form-control-sm" placeholder="Descrição..." v-model="controle.filtros.nome" @keyup="pesquisar" />
        </div>

        <div class="col-6 col-md-3">
          <label>Tipo</label>
          <select class="form-select form-select-sm" v-model="controle.filtros.tipo" @change="pesquisar">
            <option :value="null">- Todos -</option>
            <option v-for="(item,idx) in controle.tipos" :value="item" :key="idx">{{ item }}</option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label>Status</label>
           <select class="form-select form-select-sm" v-model="controle.filtros.ativo" @change="pesquisar">
            <option v-for="(item,idx) in controle.listaStatus" :value="item.valor" :key="idx">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <RouterLink class="btn btn-primary btn-sm mt-4 float-end" :to="'/planos/cadastro'"><i class="flaticon-plus"></i> Adicionar</RouterLink>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 table-responsive">
          <table class="table  align-middle mb-0 table-hover">
            <thead>
              <tr>
                <th @click="ordenarPor('usuarioId')" class="th-sortable">Id</th>
                <th @click="ordenarPor('nomeCompleto')" class="th-sortable">Nome</th>
                <th @click="ordenarPor('tipoId')" class="th-sortable">Tipo</th>
                <th @click="ordenarPor('email')" class="th-sortable">Valor</th>
                <th @click="ordenarPor('ativo')" class="th-sortable">Status</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,idx) in controle.itens" :key="idx" class="align-middle">
                <td>{{item.planoId}}</td>
                <td class="nowrap-celular">
                  {{item.nome}}
                </td>
                <td>{{item.tipo}}</td>
                <td class="text-end">{{f2dec(item.valor)}}</td>
                <td>
                  <span class="badge rounded-pill" :class="item.ativo ? 'badge-soft-success' : 'badge-soft-danger'">
                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td class="text-center text-nowrap">
                  <span>
                     <RouterLink class="text-primary" :to="'/planos/cadastro/' + item.planoId">
                      <i class="flaticon-pen fs-5"></i>
                    </RouterLink>

                     <a class="text-danger" href="javascript:void(0);" >
                        <i  class="flaticon-delete fs-5 ms-2" ></i>
                      </a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mt-2">
        <div class="col-md-4">
          {{ controle.itens.length }} Registros
        </div>
        <div class="col-md-6">
          <Paginador class="float-end"
            :paginaAtual="controle.filtros.paginaAtual"
            :tamanhoPagina="controle.filtros.tamanhoPagina"
            :totalItens="controle.itens.length"
            @paginaMudou="pesquisar"/>
        </div>
        <div class="col-md-2">
          <RouterLink class="btn btn-secondary btn-sm  float-end" :to="'/'"><i class="flaticon-close"></i> Fechar</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>

.form-control {
  background: #F5F4FA;
}

.th-sortable {
  cursor: pointer;
  user-select: none;
}

  a {
    text-decoration: none;
  }

  /* Evita quebra de linha nas colunas de nome/telefone apenas no celular */
  @media (max-width: 767.98px) {
    .nowrap-celular {
      white-space: nowrap;
    }
  }

</style>
